import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ConversationExportedInFormSubmissionAuditItemDetails = ({ audit }) => {
  const { conversation } = audit
  const { title } = conversation

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> included the conversation <span className="font-semibold">{title}</span> in an export of the form submission.
      </span>
    </div>
  )
}

ConversationExportedInFormSubmissionAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ConversationExportedInFormSubmissionAuditItemDetails
